import React, { Suspense, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import createLabelWithIcon from '#component/icon/label-icons';
import PreloaderComponent from '#component/preloader';
import DeviceEvents from '#component/device/overview/events';
import Sidebar from '#component/sidebar';
import {
  MeasurementsWrapper,
  ContentContainer,
  TabContainer,
  TabBar,
  StyledTab,
  StyledDivider
} from '#component/device/overview/styles';
import { getOverviewHeaderHeight } from '#helper';

const DeviceMeasurements = React.lazy(() => import('#component/device/overview/measurements'));

const EVENTS_TAB = 100;
const MAP_TAB = 90;

function DesktopView(props) {
  const {
    identifiersLoading,
    isInRange,
    chartDateRange,
    isWidthDownMd,
    MapComponent,
    parentState,
    identifiers,
    setChart,
    history,
    devices,
    account,
    events,
    match,
    tab,
    DevicesListComponent,
    sidebarProps,
    sidebarSharedProps,
    sidebarComponentsProps,
    handleMeasurementClick,
    sidebarSharedProps: { setClickedEvents, setClickedDevices, clickedDevices, setSelectedAxis }
  } = props;

  const mapIconLabel = createLabelWithIcon('map', MAP_TAB === tab, isWidthDownMd || identifiers.length > 4);
  const eventsIconLabel = createLabelWithIcon('events', EVENTS_TAB === tab, true);
  const overviewHeaderHeight = getOverviewHeaderHeight();
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    setHeaderHeight(overviewHeaderHeight);
  }, [overviewHeaderHeight]);

  const tabProps = value => {
    const { match: { params: { deviceId, startDate, endDate } } } = props;
    return {
      value,
      component: Link,
      to: `/device/${deviceId}/t/${value}/dr/${startDate}/${endDate}`,
      replace: true,
      onClick: () => {
        setClickedEvents([]);
        setClickedDevices([]);
        setSelectedAxis(undefined);
      }
    };
  };

  return (
    <ContentContainer container spacing={2} style={{ height: `calc(100% - ${headerHeight}px)` }}>
      {!isWidthDownMd &&
      <Sidebar
        history={history}
        account={account}
        {...sidebarProps}
        {...sidebarSharedProps}
        sidebarComponentsProps={sidebarComponentsProps}
      />}
      <MeasurementsWrapper item xs={12} md={9}>
        {!identifiersLoading ? (
          <>
            <TabContainer>
              <TabBar
                position="static"
                color="default"
                elevation={0}
              >
                <Tabs value={tab} variant="scrollable">
                  {isWidthDownMd &&
                  <StyledTab label={eventsIconLabel} {...tabProps(EVENTS_TAB)} />}
                  {identifiers.map((identifier, index) => {
                    const isActive = index === tab;
                    const isMobile = isWidthDownMd || identifiers.length > 4;
                    const label = createLabelWithIcon(identifier, isActive, isMobile);
                    return <StyledTab
                      title={identifier}
                      key={identifier}
                      label={label}
                      {...tabProps(index)}
                    />;
                  })}
                  <StyledTab label={mapIconLabel} title="map" {...tabProps(MAP_TAB)} />
                </Tabs>
              </TabBar>
              <StyledDivider />
            </TabContainer>
            {identifiers[tab] && (!parentState[`${identifiers[tab]}Loading`] ? (
              <Suspense fallback={<PreloaderComponent style={{ transform: 'initial' }} />}>
                <DeviceMeasurements
                  isInRange={isInRange}
                  identifier={identifiers[tab]}
                  selectedDevices={devices}
                  events={events}
                  range={chartDateRange}
                  setChart={setChart}
                  match={match}
                  clickEvents={setClickedEvents}
                  clickMeasurement={handleMeasurementClick}
                />
              </Suspense>
            ) : (
              <PreloaderComponent style={{ transform: 'initial' }} />
            ))}
            {tab === EVENTS_TAB && isWidthDownMd && (
              !clickedDevices.length ?
                <DeviceEvents
                  events={events}
                  history={history}
                  account={account}
                /> :
                DevicesListComponent
            )}
            {tab === MAP_TAB && MapComponent}
          </>
        ) : (
          <PreloaderComponent style={{ transform: 'initial' }} />
        )}
      </MeasurementsWrapper>
    </ContentContainer>
  );
}

export default DesktopView;
